"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationsIcon = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var IntegrationsIcon = function IntegrationsIcon(_ref) {
  var color = _ref.color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 24 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 24 : _ref$width,
      props = _objectWithoutProperties(_ref, ["color", "height", "width"]);

  return _react2.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: color,
    height: height,
    width: width
  }, props), _react2.default.createElement("path", {
    d: "M4.85 17.48a.332.332 0 0 0-.1.12V20c0 .686.564 1.25 1.25 1.25h12c.686 0 1.25-.564 1.25-1.25V9c0-.686-.564-1.25-1.25-1.25h-3.16a1.203 1.203 0 0 1-1.11-.6 1.182 1.182 0 0 1 0-1.22c.256-.44.426-.926.5-1.43l.001-.045c0-.963-.793-1.756-1.756-1.756-.946 0-1.731.765-1.755 1.711.071.563.258 1.104.55 1.59a1.23 1.23 0 0 1 0 1.18c-.209.36-.585.593-1 .62H6A1.255 1.255 0 0 0 4.75 9v2.4a.19.19 0 0 0 .08.15c.049.035.11 0 .08.06a4.705 4.705 0 0 1 1.59-.36 3.265 3.265 0 0 1 3.25 3.25 3.265 3.265 0 0 1-3.25 3.25 4.654 4.654 0 0 1-1.5-.32.253.253 0 0 0-.15.05zM15.27 6.25H18A2.763 2.763 0 0 1 20.75 9v11A2.763 2.763 0 0 1 18 22.75H6A2.763 2.763 0 0 1 3.25 20v-2.46A1.755 1.755 0 0 1 5.35 16h.14c.318.134.656.215 1 .24.96 0 1.75-.79 1.75-1.75s-.79-1.75-1.75-1.75a3.442 3.442 0 0 0-1.08.26 1.7 1.7 0 0 1-.47.067A1.699 1.699 0 0 1 3.25 11.4V9A2.763 2.763 0 0 1 6 6.25h3.73a5.671 5.671 0 0 1-.48-1.75 3.266 3.266 0 0 1 3.247-3.379A3.265 3.265 0 0 1 15.74 4.59a5.457 5.457 0 0 1-.47 1.66z"
  }), "/>");
};

exports.IntegrationsIcon = IntegrationsIcon;